module.exports = __webpack_public_path__ + "static/media/pos_debt_management.f99e9468.jpg";